/**
 * Function to calculate working days between two dates, excluding weekends (Saturday and Sunday),
 * and also excluding specified holidays.
 * @param {Date} startDate - The start date of the range.
 * @param {Date} endDate - The end date of the range.
 * @param {Array} holidays - An array of holiday dates to exclude from working days.
 * @returns {number} - The total number of working days.
 */
export const calculateWorkingDays = (startDate, endDate, holidays = []) => {
  let totalWorkingDays = 0;
  const currentDate = new Date(startDate);

  // Convert holidays array into Date objects for comparison
  const holidayDates = holidays.map((holiday) => new Date(holiday.date).toLocaleDateString());

  while (currentDate <= endDate) {
    const dayOfWeek = currentDate.getDay();
    const currentDateString = currentDate.toLocaleDateString();

    // Exclude weekends (Sunday = 0, Saturday = 6) and check if the current day is in the holiday list
    if (dayOfWeek !== 0 && dayOfWeek !== 6 && !holidayDates.includes(currentDateString)) {
      totalWorkingDays += 1;
    }

    // Move to the next day
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return totalWorkingDays;
};